import axios from 'axios';
import humps from 'humps';

import { trackException } from '../helpers/errorTracker';

const defaultOptions = {
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/`,
  headers: {
    Accept: 'application/json',
  },
  method: 'GET',
  transformResponse: [...axios.defaults.transformResponse, (data) => humps.camelizeKeys(data)],
  transformRequest: [
    (data) => {
      if (!data) return data;
      // Preserve raw data that shouldn't be transformed (e.g., submissionData with exact field labels)
      const { _rawData, ...rest } = data;
      const transformed = humps.decamelizeKeys(rest);
      if (_rawData) {
        Object.entries(_rawData).forEach(([key, value]) => {
          transformed[humps.decamelize(key)] = value;
        });
      }
      return transformed;
    },
    ...axios.defaults.transformRequest,
  ],
  withCredentials: true,
};

export const request = async (url, options = {}) => {
  const customOptions = { ...defaultOptions, ...options };

  try {
    if (customOptions.version === 'v2') {
      customOptions.baseURL = `${import.meta.env.VITE_API_V2_BASE_URL}/`;
    }

    if (customOptions.network) {
      customOptions.baseURL += `collections/${customOptions.network}`;
    }

    const result = await axios(url, {
      ...customOptions,
      headers: {
        ...defaultOptions.headers,
        ...customOptions.headers,
      },
      params: humps.decamelizeKeys(customOptions.params),
    });

    return { data: result.data };
  } catch (error) {
    trackException(error, {
      url,
      method: customOptions.method,
      data: customOptions.data,
      params: customOptions.params,
    });

    return {
      error: {
        status: error.response?.status,
        data: error.response?.data || error.message,
      },
    };
  }
};

export const get = (url, options = {}) => request(url, { ...options, method: 'GET' });
export const post = (url, data, options = {}) => request(url, { ...options, method: 'POST', data });
export const put = (url, data, options = {}) => request(url, { ...options, method: 'PUT', data });
export const del = (url, options = {}) => request(url, { ...options, method: 'DELETE' });
